import {faEdit, faPause, faPlay, faTrash} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'antd';

import {useLocale} from '../../../../provider/locale/locale-hook';
import {useChangePromotionStatus, useDeletePromotion} from '../../../../service/promotions/promotions-hook';
import {CommonPromotionStatusEnum, PromotionListItemType} from '../../../../service/promotions/promotions-type';

type PromotionActionsPropsType = {
    promotion: PromotionListItemType;
    onEdit: (promotionId: number) => void;
};

export function PromotionActions({promotion, onEdit}: PromotionActionsPropsType): JSX.Element {
    const {getLocalizedString} = useLocale();
    const deletePromotion = useDeletePromotion();
    const changeStatus = useChangePromotionStatus(promotion.id);

    const isDeleted = promotion.status === CommonPromotionStatusEnum.Deleted;
    const canPause = promotion.status === CommonPromotionStatusEnum.Sent;
    const canResume = promotion.status === CommonPromotionStatusEnum.Paused;

    function handleDelete(): void {
        Modal.confirm({
            title: getLocalizedString('PROMOTIONS__CONFIRM__DELETE__TITLE'),
            content: getLocalizedString('PROMOTIONS__CONFIRM__DELETE__DESCRIPTION'),
            okType: 'danger',
            onOk: () => deletePromotion.mutate(promotion.id),
        });
    }

    function handlePause(): void {
        Modal.confirm({
            title: getLocalizedString('PROMOTIONS__CONFIRM__PAUSE__TITLE'),
            content: getLocalizedString('PROMOTIONS__CONFIRM__PAUSE__DESCRIPTION'),
            onOk: () => changeStatus.mutate(CommonPromotionStatusEnum.Paused),
        });
    }

    function handleResume(): void {
        Modal.confirm({
            title: getLocalizedString('PROMOTIONS__CONFIRM__RESUME__TITLE'),
            content: getLocalizedString('PROMOTIONS__CONFIRM__RESUME__DESCRIPTION'),
            onOk: () => changeStatus.mutate(CommonPromotionStatusEnum.Sent),
        });
    }

    return (
        <div style={{display: 'flex', gap: 4}}>
            {canResume ? (
                <Button
                    icon={<FontAwesomeIcon icon={faPlay} />}
                    loading={changeStatus.isLoading}
                    onClick={handleResume}
                    size="small"
                    type="text"
                />
            ) : (
                <Button
                    disabled={!canPause}
                    icon={<FontAwesomeIcon icon={faPause} />}
                    loading={changeStatus.isLoading}
                    onClick={handlePause}
                    size="small"
                    type="text"
                />
            )}
            <Button
                disabled={isDeleted}
                icon={<FontAwesomeIcon icon={faEdit} />}
                onClick={() => onEdit(promotion.id)}
                size="small"
                type="text"
            />
            <Button
                danger
                disabled={isDeleted}
                icon={<FontAwesomeIcon icon={faTrash} />}
                loading={deletePromotion.isLoading}
                onClick={handleDelete}
                size="small"
                type="text"
            />
        </div>
    );
}
